export default {
  data() {
    return {
      list: [
        {
          des: "企业数字化采购管理",
          name: "企采采",
          path: "/",
        },
        {
          des: "企业的在线销售商城",
          name: "企商城",
          path: "/",
        },
        {
          des: "企业的渠道管理",
          name: "企店Pro",
          path: "/",
        },
        {
          des: "企业业务人员管理",
          name: "移动访销",
          path: "/",
        },
        {
          des: "企业供应链金融服务",
          name: "供应链金融",
          path: "/",
        },
      ],
    };
  },
};
